import css from 'styled-jsx/css';
import { colorPalette, grayLighter } from 'styles/css-constants';

export default css`
  .Spread__description,
  .Spread__title {
    margin-right: 0;
    margin-left: 0;
  }

  .Spread__item {
    margin-bottom: 1rem;
    border-bottom: 1px solid ${grayLighter};
    padding-bottom: 1rem;
  }

  .Spread__item:last-child {
    border-bottom: none;
  }

  .Spread__items {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
  }

  /* CLEANUP Abstract out title styles, so they can be used */
  /* as a new SpreadBundle title style                      */
  .Spread__title {
    justify-content: center;
    border-top: 2px solid ${colorPalette.gray};
    border-bottom: none;
    padding: 1rem 0;
  }

  .Spread__title h4 {
    color: $gray--darker;
    font-size: var(--fontScaleNeg1);
    font-weight: normal;
    text-align: center;

    font-size: 18px;
  }

  @media (min-width: 48rem) {
    .Spread__items {
      width: 100%;
      padding: 0;
    }

    .Spread__title {
      margin: 0rem;

    }

    .Spread__title h4 {
      font-size: var(--fontScaleNeg1);
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      width: 100%;
    }

    .Spread__title h4 {
      font-size: var(--fontScale1);
    }
  }

  @media (min-width: 75rem) {
    .Spread__items {
      width: 100%;
    }
  }

  @supports (display: grid) {
    @media (min-width: 64rem) {
    .Spread--thumbnailList {
      grid-template:
        'title'
        'description'
        'items'
        / 100%;
    }

    .Spread__title,
    .Spread__description,
    .Spread__link {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;
